import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { StyleClassModule } from 'primeng/styleclass';
import { ConfiguratorComponent } from '../configurator/configurator.component';
import { LayoutService } from '../../../core/services/conf/layout.service';
import { AuthService } from '../../../core/services/conf/auth.service';
import { DialogModule } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';
import { Roles } from '../../../core/services/conf/permission.service';

@Component({
    selector: 'app-topbar',
    imports: [RouterModule, CommonModule, StyleClassModule, ConfiguratorComponent, TooltipModule, DialogModule, ButtonModule],
    templateUrl: './topbar.component.html',
    styleUrl: './topbar.component.scss'
})
export class TopbarComponent implements OnInit {
    private authService = inject(AuthService);
    displayConfirmation: boolean = false;

    isEcommerceUser: boolean = false;

    items!: MenuItem[];

    nombreUsuario: string = '';

    constructor(
        public layoutService: LayoutService,
        private router: Router
    ) {
        // this.isEcommerceUser = this.authService.getCurrentUser()?.roleName.includes(Roles.CLIENTE) || false;
    }
    ngOnInit() {
        this.isEcommerceUser = this.authService.getCurrentUser()?.roleName.includes(Roles.CLIENTE) || false;
        this.nombreUsuario = 'Bienvenido/a ' + this.authService.getCurrentUser()?.name || 'Desconocido';

        if (this.isEcommerceUser) {
            // Forzar el sidebar cerrado para usuarios ecommerce
            this.layoutService.layoutState.update((state) => ({
                ...state,
                staticMenuDesktopInactive: true,
                overlayMenuActive: false,
                staticMenuMobileActive: false
            }));
        } else {
            // Forzar el sidebar cerrado para usuarios ecommerce
            this.layoutService.layoutState.update((state) => ({
                ...state,
                staticMenuDesktopInactive: false,
                overlayMenuActive: false,
                staticMenuMobileActive: false
            }));
        }
    }

    toggleDarkMode() {
        this.layoutService.layoutConfig.update((state) => ({
            ...state,
            darkTheme: !state.darkTheme
        }));
    }

    goto(ruta: string) {
        this.router.navigate([ruta]);
    }

    openConfirmation() {
        this.displayConfirmation = true;
    }

    closeConfirmation(confirmation: boolean) {
        if (confirmation) {
            this.authService.logout(); // 🔥 Esto limpia todo y redirige
        }
        this.displayConfirmation = false;
    }
}
